import React from 'react'
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import ContactForm from "../../components/ContactForm"

const Contact = () => (
  <Layout>
    <SEO title="contact" />
    <ContactForm/>
  </Layout>
)

export default Contact
